import React from 'react';
import Icon from '@ant-design/icons';
import { ReactComponent as IconStaffSvg }  from '../../assets/icons/icon_vrs_server_blue.svg';

const VRSServerIcon=(props)=>{
    return <Icon component={() => <IconStaffSvg />} {...props}/>
}

export default VRSServerIcon;